import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import GameAbstract from '../core/GameAbstract';
import Template from 'frontools/data/Template';
import { autobind } from 'frontools/decorators/Autobind';
import { Assets } from '../core/Assets';
import NumberUtils from 'frontools/utils/NumberUtils';
import { GameMode, GameManager } from '../core/GameManager';
import { Level, ILevelConfig } from "sources/js/becquerbobo/Level";

declare var dataLayer           : any;

export class Becquerbobo extends GameAbstract {

    public static CLICK                     : string                        = 'click';
    public static TAP                       : string                        = 'tap';
    private _currentLevel                   : number                                  = 0;
    private _levels                         : Level[]                                 = [];
    private _levelWrapper                   : PIXI.Container                          = new PIXI.Container;
    private _levelConfig                    : ILevelConfig[]                                = [
        {
            character: 'gameplayBras',
            scaleX: -1,
            speed: 500,
            framesCount:42,
            progressClickStep: 5,
            progressTapStep: 4,
        },
        {
            character: 'gameplayBras',
            scaleX: 1,
            speed: 400,
            framesCount:42,
            progressClickStep: 4,
            progressTapStep: 3,
        },
        {
            character: 'gameplayJambe',
            scaleX: -1,
            speed: 350,
            framesCount:58,
            progressClickStep: 3,
            progressTapStep: 2,
        },
        {
            character: 'gameplayJambe',
            scaleX: 1,
            speed: 300,
            framesCount:58,
            progressClickStep: 2,
            progressTapStep: 1,
        }
    ];


    constructor() {
        
        super({
            time: 20,
            results: [
                '0-100',
                '101-150',
                '151-9999'
            ],
            assets: [
                { name: 'boutonBec', url: 'sprite/face/boutonBec.json' },
                { name: 'mouth', url: 'sprite/bec_fly.png' },
                { name: 'end', url: 'audio/end.mp3' },
                { name: 'level', url: 'audio/level.mp3' },
                { name: 'bec1', url: 'audio/bec1.mp3' },
                { name: 'voix1', url: 'audio/voix1.mp3' },
                { name: 'voix2', url: 'audio/voix2.mp3' },
                { name: 'voix3', url: 'audio/voix3.mp3' },
                { name: 'voix4', url: 'audio/voix4.mp3' },
                { name: 'gameplayBras1', url: 'sprite/gameplayBras/gameplayBras0001.png', init: false }, {name: 'gameplayBras2', url: 'sprite/gameplayBras/gameplayBras0006.png', init: false }, {name: 'gameplayBras3', url: 'sprite/gameplayBras/gameplayBras0007.png', init: false }, {name: 'gameplayBras4', url: 'sprite/gameplayBras/gameplayBras0008.png', init: false }, {name: 'gameplayBras5', url: 'sprite/gameplayBras/gameplayBras0009.png', init: false }, {name: 'gameplayBras6', url: 'sprite/gameplayBras/gameplayBras0010.png', init: false }, {name: 'gameplayBras7', url: 'sprite/gameplayBras/gameplayBras0011.png', init: false }, {name: 'gameplayBras8', url: 'sprite/gameplayBras/gameplayBras0012.png', init: false }, {name: 'gameplayBras9', url: 'sprite/gameplayBras/gameplayBras0013.png', init: false }, {name: 'gameplayBras10', url: 'sprite/gameplayBras/gameplayBras0014.png', init: false }, {name: 'gameplayBras11', url: 'sprite/gameplayBras/gameplayBras0015.png', init: false }, {name: 'gameplayBras12', url: 'sprite/gameplayBras/gameplayBras0016.png', init: false }, {name: 'gameplayBras13', url: 'sprite/gameplayBras/gameplayBras0017.png', init: false }, {name: 'gameplayBras14', url: 'sprite/gameplayBras/gameplayBras0018.png', init: false }, {name: 'gameplayBras15', url: 'sprite/gameplayBras/gameplayBras0019.png', init: false }, {name: 'gameplayBras16', url: 'sprite/gameplayBras/gameplayBras0020.png', init: false }, {name: 'gameplayBras17', url: 'sprite/gameplayBras/gameplayBras0021.png', init: false }, {name: 'gameplayBras18', url: 'sprite/gameplayBras/gameplayBras0022.png', init: false }, {name: 'gameplayBras19', url: 'sprite/gameplayBras/gameplayBras0023.png', init: false }, {name: 'gameplayBras20', url: 'sprite/gameplayBras/gameplayBras0024.png', init: false }, {name: 'gameplayBras21', url: 'sprite/gameplayBras/gameplayBras0025.png', init: false }, {name: 'gameplayBras22', url: 'sprite/gameplayBras/gameplayBras0026.png', init: false }, {name: 'gameplayBras23', url: 'sprite/gameplayBras/gameplayBras0027.png', init: false }, {name: 'gameplayBras24', url: 'sprite/gameplayBras/gameplayBras0028.png', init: false }, {name: 'gameplayBras25', url: 'sprite/gameplayBras/gameplayBras0029.png', init: false }, {name: 'gameplayBras26', url: 'sprite/gameplayBras/gameplayBras0030.png', init: false }, {name: 'gameplayBras27', url: 'sprite/gameplayBras/gameplayBras0031.png', init: false }, {name: 'gameplayBras28', url: 'sprite/gameplayBras/gameplayBras0032.png', init: false }, {name: 'gameplayBras29', url: 'sprite/gameplayBras/gameplayBras0033.png', init: false }, {name: 'gameplayBras30', url: 'sprite/gameplayBras/gameplayBras0034.png', init: false }, {name: 'gameplayBras31', url: 'sprite/gameplayBras/gameplayBras0035.png', init: false }, {name: 'gameplayBras32', url: 'sprite/gameplayBras/gameplayBras0036.png', init: false }, {name: 'gameplayBras33', url: 'sprite/gameplayBras/gameplayBras0037.png', init: false }, {name: 'gameplayBras34', url: 'sprite/gameplayBras/gameplayBras0038.png', init: false }, {name: 'gameplayBras35', url: 'sprite/gameplayBras/gameplayBras0039.png', init: false }, {name: 'gameplayBras36', url: 'sprite/gameplayBras/gameplayBras0040.png', init: false }, {name: 'gameplayBras37', url: 'sprite/gameplayBras/gameplayBras0041.png', init: false }, {name: 'gameplayBras38', url: 'sprite/gameplayBras/gameplayBras0042.png', init: false }, {name: 'gameplayBras39', url: 'sprite/gameplayBras/gameplayBras0043.png', init: false }, {name: 'gameplayBras40', url: 'sprite/gameplayBras/gameplayBras0044.png', init: false }, {name: 'gameplayBras41', url: 'sprite/gameplayBras/gameplayBras0045.png', init: false }, {name: 'gameplayBras42', url: 'sprite/gameplayBras/gameplayBras0046.png', init: false }, 

                { name: 'gameplayJambe1', url: 'sprite/gameplayJambe/gameplayJambe0001.png', init: false }, {name: 'gameplayJambe2', url: 'sprite/gameplayJambe/gameplayJambe0005.png', init: false }, {name: 'gameplayJambe3', url: 'sprite/gameplayJambe/gameplayJambe0006.png', init: false }, {name: 'gameplayJambe4', url: 'sprite/gameplayJambe/gameplayJambe0007.png', init: false }, {name: 'gameplayJambe5', url: 'sprite/gameplayJambe/gameplayJambe0008.png', init: false }, {name: 'gameplayJambe6', url: 'sprite/gameplayJambe/gameplayJambe0009.png', init: false }, {name: 'gameplayJambe7', url: 'sprite/gameplayJambe/gameplayJambe0010.png', init: false }, {name: 'gameplayJambe8', url: 'sprite/gameplayJambe/gameplayJambe0011.png', init: false }, {name: 'gameplayJambe9', url: 'sprite/gameplayJambe/gameplayJambe0012.png', init: false }, {name: 'gameplayJambe10', url: 'sprite/gameplayJambe/gameplayJambe0013.png', init: false }, {name: 'gameplayJambe11', url: 'sprite/gameplayJambe/gameplayJambe0014.png', init: false }, {name: 'gameplayJambe12', url: 'sprite/gameplayJambe/gameplayJambe0015.png', init: false }, {name: 'gameplayJambe13', url: 'sprite/gameplayJambe/gameplayJambe0016.png', init: false }, {name: 'gameplayJambe14', url: 'sprite/gameplayJambe/gameplayJambe0017.png', init: false }, {name: 'gameplayJambe15', url: 'sprite/gameplayJambe/gameplayJambe0018.png', init: false }, {name: 'gameplayJambe16', url: 'sprite/gameplayJambe/gameplayJambe0019.png', init: false }, {name: 'gameplayJambe17', url: 'sprite/gameplayJambe/gameplayJambe0020.png', init: false }, {name: 'gameplayJambe18', url: 'sprite/gameplayJambe/gameplayJambe0021.png', init: false }, {name: 'gameplayJambe19', url: 'sprite/gameplayJambe/gameplayJambe0022.png', init: false }, {name: 'gameplayJambe20', url: 'sprite/gameplayJambe/gameplayJambe0023.png', init: false }, {name: 'gameplayJambe21', url: 'sprite/gameplayJambe/gameplayJambe0024.png', init: false }, {name: 'gameplayJambe22', url: 'sprite/gameplayJambe/gameplayJambe0025.png', init: false }, {name: 'gameplayJambe23', url: 'sprite/gameplayJambe/gameplayJambe0026.png', init: false }, {name: 'gameplayJambe24', url: 'sprite/gameplayJambe/gameplayJambe0027.png', init: false }, {name: 'gameplayJambe25', url: 'sprite/gameplayJambe/gameplayJambe0028.png', init: false }, {name: 'gameplayJambe26', url: 'sprite/gameplayJambe/gameplayJambe0029.png', init: false }, {name: 'gameplayJambe27', url: 'sprite/gameplayJambe/gameplayJambe0030.png', init: false }, {name: 'gameplayJambe28', url: 'sprite/gameplayJambe/gameplayJambe0031.png', init: false }, {name: 'gameplayJambe29', url: 'sprite/gameplayJambe/gameplayJambe0032.png', init: false }, {name: 'gameplayJambe30', url: 'sprite/gameplayJambe/gameplayJambe0033.png', init: false }, {name: 'gameplayJambe31', url: 'sprite/gameplayJambe/gameplayJambe0034.png', init: false }, {name: 'gameplayJambe32', url: 'sprite/gameplayJambe/gameplayJambe0035.png', init: false }, {name: 'gameplayJambe33', url: 'sprite/gameplayJambe/gameplayJambe0036.png', init: false }, {name: 'gameplayJambe34', url: 'sprite/gameplayJambe/gameplayJambe0037.png', init: false }, {name: 'gameplayJambe35', url: 'sprite/gameplayJambe/gameplayJambe0038.png', init: false }, {name: 'gameplayJambe36', url: 'sprite/gameplayJambe/gameplayJambe0039.png', init: false }, {name: 'gameplayJambe37', url: 'sprite/gameplayJambe/gameplayJambe0040.png', init: false }, {name: 'gameplayJambe38', url: 'sprite/gameplayJambe/gameplayJambe0041.png', init: false }, {name: 'gameplayJambe39', url: 'sprite/gameplayJambe/gameplayJambe0042.png', init: false }, {name: 'gameplayJambe40', url: 'sprite/gameplayJambe/gameplayJambe0043.png', init: false }, {name: 'gameplayJambe41', url: 'sprite/gameplayJambe/gameplayJambe0044.png', init: false }, {name: 'gameplayJambe42', url: 'sprite/gameplayJambe/gameplayJambe0045.png', init: false }, {name: 'gameplayJambe43', url: 'sprite/gameplayJambe/gameplayJambe0046.png', init: false }, {name: 'gameplayJambe44', url: 'sprite/gameplayJambe/gameplayJambe0047.png', init: false }, {name: 'gameplayJambe45', url: 'sprite/gameplayJambe/gameplayJambe0048.png', init: false }, {name: 'gameplayJambe46', url: 'sprite/gameplayJambe/gameplayJambe0049.png', init: false }, {name: 'gameplayJambe47', url: 'sprite/gameplayJambe/gameplayJambe0050.png', init: false }, {name: 'gameplayJambe48', url: 'sprite/gameplayJambe/gameplayJambe0051.png', init: false }, {name: 'gameplayJambe49', url: 'sprite/gameplayJambe/gameplayJambe0052.png', init: false },{name: 'gameplayJambe50', url: 'sprite/gameplayJambe/gameplayJambe0053.png', init: false },{name: 'gameplayJambe51', url: 'sprite/gameplayJambe/gameplayJambe0054.png', init: false },{name: 'gameplayJambe52', url: 'sprite/gameplayJambe/gameplayJambe0055.png', init: false },{name: 'gameplayJambe53', url: 'sprite/gameplayJambe/gameplayJambe0056.png', init: false },{name: 'gameplayJambe54', url: 'sprite/gameplayJambe/gameplayJambe0057.png', init: false },{name: 'gameplayJambe55', url: 'sprite/gameplayJambe/gameplayJambe0058.png', init: false },{name: 'gameplayJambe56', url: 'sprite/gameplayJambe/gameplayJambe0059.png', init: false },{name: 'gameplayJambe57', url: 'sprite/gameplayJambe/gameplayJambe0060.png', init: false },{name: 'gameplayJambe58', url: 'sprite/gameplayJambe/gameplayJambe0061.png', init: false },
            ]
            
        });

    };


    /*
     * @core override
     * _onPreloadComplete - Called when the preload has been completed
     * 
     */
    protected _onPreloadComplete() {
        super._onPreloadComplete();
    };


    /*
     * @core override
     * _prepare - Prepare the game components and then starts the countdown
     * 
     */    
    protected _prepare() {
        this._stage.addChild(Assets.sprites['boutonBec']);
        
        this._generateLevel(this._currentLevel, false);

        // Prepare face sprite
        Assets.sprites['boutonBec'].animationSpeed = 1.2;
        Assets.sprites['boutonBec'].loop = false;
        Assets.sprites['boutonBec'].buttonMode = true;
        Assets.sprites['boutonBec'].interactive = true;

        
        Assets.sprites['boutonBec'].on(Becquerbobo.CLICK, this._onHit, this);
        Assets.sprites['boutonBec'].on(Becquerbobo.TAP, this._onHit, this);
        
        // Trigger components positioning
        // Note: This will initialise core game components and start the countdown
        super._prepare(); 
    };


    private _generateLevel(index: number, active: boolean = true) {
        let level = new Level(this._levelConfig[index] as ILevelConfig);

        // custom tracking for Becquerbobo
        if (this._currentLevel > 0) {
            dataLayer.push({URI: '/jeu-educatifs/' + this._config.name +'/jeu/etape'+ (this._currentLevel + 1), event: 'virtualPageview'});
        }
        
        if (active === false) level.disable();
        
        this._levels.push(level);
        this._resize();
        //TweenMax.from(level.container, .5, {x: "+=400", alpha: 1, ease: Expo.easeOut});

        // Events
        level.addListener(Level.COMPLETE, this._onLevelComplete);
        level.addListener(Level.HIT, this._onHit);
        level.addListener(Level.RETRACT, this._onSkinRetract);
        
    };

    /*
     * _generateMouth - Genrate mouth on click and animate it
     * 
     */
    private _generateMouth() {
        
        var mouth = new PIXI.Sprite((Assets.sprites['mouth'] as PIXI.Sprite).texture);
        mouth.position.x = Assets.sprites['boutonBec'].width / 3;
        Assets.sprites['boutonBec'].addChild(mouth);
        
        var amplitude= 80;
        var tl = new TimelineMax();
        tl.to(mouth, 0.1, {x: (Math.random() * amplitude)+mouth.position.x , y: -20, alpha: 0.8}) 
            .to(mouth, 0.1, {x: (Math.random() * amplitude)+mouth.position.x , y: -40, alpha: 0.6}) 
            .to(mouth, 0.1, {x: (Math.random() * amplitude)+mouth.position.x , y: -60, alpha: 0.4}) 
            .to(mouth, 0.1, {x: (Math.random() * amplitude)+mouth.position.x , y: -80, alpha: 0.2})
            .to(mouth, 0.1, {x: (Math.random() * amplitude)+mouth.position.x , y: -100, alpha: 0}) ;

    }

    /*
     * _onLevelComplete - Starts the game
     * 
     */
    @autobind
    private _onLevelComplete(e) {
        this._gameScore.add(this._gameTimer.timeLeft);

        this._levels[this._currentLevel].removeListener(Level.HIT, this._onHit);
        this._levels[this._currentLevel].destroy();
        e.target.removeListener(Level.COMPLETE, this._onLevelComplete);

        if (this._currentLevel >= this._levelConfig.length -1) {
            this._gameTimer.stop(); // This trigger the end game
        } else {
            Assets.sounds['level'].play();
            this._currentLevel++;
            this._generateLevel(this._currentLevel);
        }
    };


    /*
     * _onLevelComplete - Starts the game
     * 
     */
    @autobind
    private _onHit(e) {
        this._gameScore.add(1);

        Assets.sprites['boutonBec'].gotoAndPlay(1);
        this._generateMouth();
        this._levels[this._currentLevel].repairSkin(e);
        // trigger ton sprite de ti bec
        var assetNumber = Math.round(Math.random()*3) + 1;

        Assets.sounds['bec1'].play();

        if(this._levels[this._currentLevel].cheerSounds()){
            if(this._levels[this._currentLevel].progress > 70 ){ 
                Assets.sounds['voix'+assetNumber].volume = .5;
            } else{ 
                Assets.sounds['voix'+assetNumber].volume = 1;
            };
            Assets.sounds['voix'+assetNumber].play();
        }
    };

    @autobind
    private _onSkinRetract(e){
        this._gameScore.remove(1);
    }


    /*
     * @core override
     * _start - Starts the game
     * 
     */
    protected _start() {
        super._start();
        this._levels[0].enable();
    };
    

    /*
     * @core override
     * _onTimerComplete - on game timer complete handler
     * @param {event} e - Event
     * 
     */
    protected _onTimerComplete(e) {
        super._onTimerComplete(e);
        Assets.sounds['end'].play();
    };


    protected _end() {
        super._end();
        this._levels[this._currentLevel].destroy();
    }


    /*
     * @core override
     * _resize - Resize handler
     * @param {event} e - Event
     * 
     */
    protected _resize(e?: Event) {
        super._resize(e);

        if (this._gameMode === GameMode.PLAYING || typeof e === 'undefined') {

            Assets.sprites['boutonBec'].x = this._screenWidth / 2 - Assets.sprites['boutonBec'].width / 2;
            Assets.sprites['boutonBec'].y = this._screenHeight - Assets.sprites['boutonBec'].height - 20;


        }

    };

}